import { OrderItemDataFragment, Enum_Orderitemaction_Action } from "data";
import { ControlBoardIcon } from "components/Icons";
import { ActionComponent, ActionComponentVariant } from "components/ActionComponent";
import { useRegisterOrderItemAction } from "features/order-items/data/hooks/order-item-actions";

interface ReplaceControlBoardActionProps {
  orderItem: OrderItemDataFragment;
  variant: ActionComponentVariant;
}

export const ReplaceControlBoardAction = (props: ReplaceControlBoardActionProps) => {
  const { orderItem, variant } = props;
  const { registerAction } = useRegisterOrderItemAction();
  return (
    <ActionComponent
      action={async () => {
        if (orderItem.id) {
          await registerAction({
            orderItem,
            action: {
              action: Enum_Orderitemaction_Action.ReplaceControlBoard,
            },
          });
        }
      }}
      variant={variant}
      actionIcon={<ControlBoardIcon />}
      actionLabel='Replace Control Board'
      data-cy='action-replace-control-board'
    />
  );
};

ReplaceControlBoardAction.defaultProps = {
  variant: "menu-item",
};
